import React from "react";
import styles from "./Cooperation.module.css";

export default function Cooperation() {
  return (
    <section id="cooperation" className="sectionContainer dark">
      <div className="sectionTitle">
        <h2>Chętnie nawiążemy współpracę</h2>
      </div>
      <p className={styles.cooperationDescribe}>
        Wierzymy, że najlepsze projekty powstają wtedy, gdy łączymy wiedzę,
        doświadczenie i różne spojrzenia. Dlatego chętnie podejmujemy współpracę
        z freelancerami, firmami oraz osobami, które podobnie jak my cenią
        jakość, kreatywność i partnerskie podejście.
      </p>

      <p className={styles.cooperationDescribe}>
        Jesteśmy otwarci na współpracę z osobami, które chcą dzielić się swoją
        wiedzą i doświadczeniem. Chętnie nawiążemy współpracę ze szkoleniowcami,
        specjalistami IT oraz osobami zajmującymi się projektowaniem graficznym,
        czy tworzeniem treści. Wierzymy, że wymiana wiedzy, doświadczenia i
        wzajemne wsparcie pozwalają tworzyć usługi na jeszcze wyższym poziomie.
      </p>

      <p className={styles.cooperationDescribe}>
        Jeśli uważasz, że możemy wspólnie stworzyć coś ciekawego lub po prostu
        chcesz porozmawiać o możliwości współpracy – zapraszamy do kontaktu. Z
        przyjemnością poznamy Twój pomysł i sprawdzimy, jak możemy się wzajemnie
        wesprzeć.
      </p>
    </section>
  );
}
